export default "__VITE_ASSET__ljY3buhE__"